import {
	Table, Popconfirm, Pagination
}from 'antd'
import {
	useEffect,
	useState
}from 'react'
import {
	useSelector, useDispatch
}from 'react-redux'
import {
	useDebounce
}from 'use-debounce'
import Notifications from '../../../helpers/Notifications'
import {
	reAddressActions
}from './store/actions'
import moment from "moment"
import CustomButton from '../../../components/CustomButton'
import CustomInput from '../../../components/CustomInput'
import DeleteIcon from '../../../components/Icons/delete.svg'
import RestoreIcon from '../../../components/Icons/restore.svg'
import UpdateIcon from '../../../components/Icons/update.svg'
import AuditIcon from '../../../components/Icons/audit.svg'
import AddIcon from '../../../components/Icons/add.svg'
import ReAddressChangeForm from "./change"
import LocalLoading from '../../../components/Loading/Local'
import ModalAudit from '../ModalAudit'
import CustomFilters from '../../../components/CustomFilters'

const ReAddress = (props) => {
	const { isModify = false } = props
	const pageSize = 10
	const [visible, setVisible] = useState(false)
	const [record, setRecord] = useState(null)
	const [count, setCount] = useState(0)
	const [table, setTable] = useState([])
	const [page, setPage] = useState(1)
	const [filter, setFilter] = useState({})
	const [visibleModalAudit, setVisibleModalAudit] = useState(false)
	const [idRecordAudit, setIdRecordAudit] = useState(null)
	const [searchFilter] = useDebounce(filter, 500)
	const { isSending, changed, paged, pagedAudit, countAudit } = useSelector((state) => state.reAddressReducer)
	const dispatch = useDispatch()

	const getPaged = params => {
		dispatch(reAddressActions.getPaged(params))
	}
	const getPagedAudit = params => {
		dispatch(reAddressActions.getPagedAudit(params))
	}
	const getPagedAll = params => {
		dispatch(reAddressActions.getPagedAll(params))
	}
	const create = params => {
		dispatch(reAddressActions.create(params))
	}
	const remove = params => {
		dispatch(reAddressActions.remove(params))
	}
	const update = params => {
		dispatch(reAddressActions.update(params))
	}
	const restore = params => {
		dispatch(reAddressActions.restore(params))
	}

	useEffect(() => {
		return () => {
			dispatch(reAddressActions.clear())
		}
	}, [])

	useEffect(() => {
		if (changed){
			Notifications.successNotice(changed, "", 15)
			onPaginationChange(page)
		}
	}, [changed])

	useEffect(() => {
		onPaginationChange(1)
	}, [searchFilter])

	useEffect(() => {
		if (paged?.items){
			setCount(paged.count)
			setTable(paged.items)
		}
	}, [paged])

	useEffect(() => {
		if (idRecordAudit){
			getPagedAudit({
				id       : idRecordAudit,
				page     : 1,
				pageSize : pageSize
			})
		}
	}, [idRecordAudit])

	function onPaginationChange(value){
		setPage(value)
		const params = {
			name                      : searchFilter?.name?.trim(),
			reAdministrativeTerritory : searchFilter?.reAdministrativeTerritory?.trim(),
			reDistrict                : searchFilter?.reDistrict?.trim(),
			reRegion                  : searchFilter?.reRegion?.trim(),
			pageSize                  : pageSize,
			page                      : value
		}
		if (isModify)
			getPagedAll(params)
		else
			getPaged(params)
	}
	const onPaginationAuditChange = (value) => {
		idRecordAudit && getPagedAudit({
			id   : idRecordAudit,
			page : value,
			pageSize
		})
	}

	const columns = [
		{
			title     : "Код",
			dataIndex : 'code',
			key       : 'code'
		},
		{
			title     : "Тип",
			dataIndex : 'reAddressTypeName',
			key       : 'reAddressTypeName'
		},
		{
			title     : "Наименование",
			dataIndex : 'name',
			key       : 'name'
		},
		{
			title     : "Населенный пункт",
			dataIndex : 'reATerFullName',
			key       : 'reATerFullName'
		},
		{
			title     : "Дата создания",
			dataIndex : 'createDate',
			key       : 'createDate',
			render    : (date) => moment(date).format("DD.MM.YYYY")
		}
	]

	isModify
		? columns.push({
			dataIndex : "id",
			key       : 'id',
			width     : 100,
			render    : (id, record) => (
				<div className="changeIcon">
					<img
						src={ UpdateIcon }
						title="Редактировать"
						onClick={ () => {
							setVisible(true)
							setRecord(record)
						} }
					/>
					<Popconfirm
						cancelText="Нет"
						okText="Да"
						placement="left"
						title={ !record.isDeleted ? 'Вы уверены, что хотите удалить данную запись?' : 'Вы уверены, что хотите восстановить данную запись?' }
						onCancel={ (e) => {
							e.stopPropagation()
							return null
						} }
						onConfirm={ (e) => {
							e.stopPropagation()
							!record.isDeleted ? remove({ id }) : restore({ id })
						} }
					>
						<img
							src={ !record.isDeleted ? DeleteIcon :RestoreIcon }
							title={ !record.isDeleted ? "Удалить" : "Восстановить" }
						/>
					</Popconfirm>
					<img
						className="audit-icon-svg"
						src={ AuditIcon }
						title="История изменений"
						onClick={ () => {
							setVisibleModalAudit(true)
							setIdRecordAudit(id)
							onPaginationAuditChange(1)
						} }
					/>
				</div>
			)
		})
		: null

	const columnsAudit = [
		{
			dataIndex : 'action',
			key       : 'action',
			title     : 'Действие',
			width     : '15%'
		},
		{
			dataIndex : 'code',
			key       : 'code',
			title     : 'Код',
			width     : '5%'
		},
		{
			title     : "Тип",
			dataIndex : 'reAddressTypeName',
			key       : 'reAddressTypeName'
		},
		{
			dataIndex : 'name',
			key       : 'name',
			title     : 'Наименование'
		},
		{
			title     : "Населенный пункт",
			dataIndex : 'reATerNumName',
			key       : 'reATerNumName'
		},
		{
			key       : 'actionDateTime',
			title     : 'Дата',
			dataIndex : 'actionDateTime',
			width     : '10%'
		},
		{
			title     : 'IP-адрес',
			key       : 'ip',
			dataIndex : 'ip',
			width     : '10%'
		}
	]

	return (
		<>
			<CustomFilters
				elements={ [
					{
						name        : "name",
						type        : "input",
						placeholder : "Введите название/код",
						onChange    : (value) => setFilter({ ...filter,
							name: value })
					},
					{
						name        : "reAdministrativeTerritory",
						type        : "input",
						placeholder : "Введите название населенного пункта",
						onChange    : (value) => setFilter({ ...filter,
							reAdministrativeTerritory: value })
					},
					{
						name        : "reDistrict",
						type        : "input",
						placeholder : "Введите название района",
						onChange    : (value) => setFilter({ ...filter,
							reDistrict: value })
					},
					{
						name        : "reRegion",
						type        : "input",
						placeholder : "Введите название области/региона",
						onChange    : (value) => setFilter({ ...filter,
							reRegion: value })
					}
				] }
				visibleButtons={ false }
			/>
			{ isModify
				? (
					<CustomButton
						className="add-nsi"
						type="green"
						onClick={ () => {
							setRecord(null)
							setVisible(true)
						} }
					>
						<div>
							<img src={ AddIcon } />
							<span>
								Добавить
							</span>
						</div>
					</CustomButton>
				)
				: null }
			<Table
				columns={ columns }
				dataSource={ table }
				loading={ { indicator : <LocalLoading />,
					spinning  : isSending } }
				pagination={ false }
				scroll={ { x: 1100 } }
			/>
			{
				count > pageSize &&
          <Pagination
          	showQuickJumper
          	current={ page }
          	pageSize={ pageSize }
          	showSizeChanger={ false }
          	size="small"
          	total={ count }
          	onChange={ onPaginationChange }
          />
			}
			{ isModify &&
        <ReAddressChangeForm
        	create={ create }
        	record={ record }
        	setRecord={ setRecord }
        	setVisible={ setVisible }
        	update={ update }
        	visible={ visible }
        /> }
			<ModalAudit
				columns={ columnsAudit }
				count={ countAudit }
				data={ pagedAudit }
				setIdRecordAudit={ setIdRecordAudit }
				setPage={ onPaginationAuditChange }
				setVisible={ setVisibleModalAudit }
				visible={ visibleModalAudit }
			/>
		</>
	)
}

export default ReAddress